<template>
  <div class="loc-map-screen">
    <!-- generic modal with map screen for location detection -->
    <generic-modal
      :height="LocationModalDim.height"
      :width="LocationModalDim.width"
      :padding="LocationModalDim.padding"
      :modalClass="LocationModalDim.modalClass"
      overflowNotNeeded="true"
    >
      <template v-slot:body>
        <span class="floating-back-btn shadow" v-if="clientPlatform == 'Web'">
          <i
            class="hkfi-close fs-22 normal mr20 hand"
            @click="handleChangeLocation"
          ></i>
        </span>
        <div class="p16" @click="handleChangeLocation('close')" v-else>
          <i class="hkfi-back fs-12 bold"></i>
          <span class="fs-16 fw-700 pl8">{{ mapHeader }}</span>
        </div>
        <!-- <div :class="[clientPlatform == 'Web' ? 'fs-16 bold' : '']">
            Set your location
          </div> -->

        <div
          class="delivery-map-container"
          ref="map"
          :style="getMapStyles"
        ></div>
        <div class="map-search-bar" @click="handleLocationSearchMap">
          <span class="fs-14 color-grey-light">{{ searchText }}</span>
          <i class="hkfi-search-lens fs-18 color-slaty"></i>
        </div>
        <div :style="{ top: markerTipTop }" class="marker-tip">
          <span class="fs-12 fw-700" v-if="isNoDeliveryZone">{{
            markerTipMessageNonDeliverable
          }}</span>
          <span class="fs-12 fw-700" v-else-if="markerTipMessageTop">{{
            markerTipMessageTop
          }}</span>
          <span
            class="fs-11 color-x-grey-light"
            v-if="markerTipMessageBottom"
            >{{ markerTipMessageBottom }}</span
          >
        </div>
        <div
          class="relocate-icon"
          :style="{ bottom: relocateBottom }"
          @click="relocateLocation"
        >
          <img
            :src="staticImgBaseUrl + '/images/global/relocate.svg'"
            alt="marker-image"
          /><span class="fs-14 fw-800 color-primary pl5"
            >Deliver to Current Location</span
          >
        </div>
      </template>
      <template v-slot:footer v-if="isLoading"
        ><map-screen-bottom-bar-shimmer
          ref="mapFooter"
        ></map-screen-bottom-bar-shimmer>
      </template>
      <template
        v-slot:footer
        v-else-if="openConfirmationModal && !isNoDeliveryZone"
      >
        <div
          :class="ConfirmAddressModalDim.modalClass"
          ref="mapFooter"
          class="map-screen-addr-modal"
        >
          <div
            class="location-different-nudge"
            v-if="distDiffBtwGpsAndDragLocText"
            v-html="distDiffBtwGpsAndDragLocText"
          ></div>
          <div class="fs-12 color-slaty mb8">Your Location</div>
          <div class="disp-col-inline jcsb mb10">
            <div class="location-container">
              <img
                :src="staticImgBaseUrl + '/images/global/location-icon.svg'"
                alt="location-icon"
              />
              <div class="location-items">
                <span class="lh18 fs-16 bold color-slaty-dark">{{
                  initialValue.geoCode.displayAddress
                }}</span>
                <span class="fs-12 lh14 color-slaty">{{
                  initialValue.geoCode.footerAddress
                }}</span>
              </div>
            </div>
            <button class="change-btn" @click="handleChangeLocation">
              Change
            </button>
          </div>
          <button
            class="cnfm-loc-btn"
            v-if="showAddAddress"
            v-on:click="handleAddNewAddress()"
          >
            Enter Complete Address
          </button>
          <button class="cnfm-loc-btn" v-else @click="handleConfirmLocation">
            Confirm Location
          </button>
        </div>
      </template>

      <template v-slot:footer v-else-if="isNoDeliveryZone">
        <div
          ref="mapFooter"
          class="cnfm-address-modal full-screen-popup lg-screen-centered"
        >
          <div>
            <div>
              <msg-holder
                :msgText="
                  nearestTakeawayStore.store
                    ? `Sorry! We don't deliver to this location currently.`
                    : `Sorry! We don't deliver to this location currently. Try changing the location`
                "
                :bgColor="msgHolderStyles.bgColor"
                :borderColor="msgHolderStyles.borderColor"
                :textColor="msgHolderStyles.color"
                msgHolderClass="location-different-nudge mb12"
              ></msg-holder>
              <div class="fs-12 color-slaty mb8">Your Selected Location</div>
              <div :class="['disp-col-inline jcsb pb16']">
                <div class="location-container">
                  <img
                    :src="staticImgBaseUrl + '/images/global/location-icon.svg'"
                    alt="location-icon"
                  />
                  <div class="location-items">
                    <span class="lh18 fs-16 bold color-slaty-dark">{{
                      initialValue.geoCode.displayAddress
                    }}</span>
                    <span class="fs-12 lh14 color-slaty">{{
                      initialValue.geoCode.footerAddress
                    }}</span>
                  </div>
                </div>
                <button class="change-btn" @click="handleChangeLocation">
                  Change
                </button>
              </div>
              <div class="gradient-stroke pd" v-if="nearestTakeawayStore.store">
                OR
              </div>
              <div
                v-if="nearestTakeawayStore.store"
                :class="{ mt16: clientPlatform == 'Web' }"
              >
                <div class="fs-14 tc fw-800">Try Takeaway Instead</div>
                <!--nearest store card-->
                <div class="border br12 pd12 mt12">
                  <address-card
                    v-if="nearestTakeawayStore.store"
                    :data-item="nearestTakeawayStore.store"
                    :data-title="nearestTakeawayStore.store.name"
                    :data-address="nearestTakeawayStore.store.address"
                    :data-distance="
                      nearestTakeawayStore.store.stations[0].driveDistanceInKm
                    "
                    :data-time="
                      nearestTakeawayStore.store.stations[0].driveTimeInSec
                    "
                    :data-is-store-open="
                      nearestTakeawayStore.store.pickUpEnable
                    "
                    :addressCardClass="addressCardClass"
                    :data-on-card-click="() => {}"
                  />
                  <button
                    class="line-btn secondary w100 mt10 fs-14 fw-800"
                    @click="handleProceedTakeaway"
                  >
                    Proceed for Takeaway
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer v-else>
        <div ref="mapFooter" class="delivery-map-screen-footer">
          <div
            class="location-different-nudge"
            v-if="distDiffBtwGpsAndDragLocText"
            v-html="distDiffBtwGpsAndDragLocText"
          ></div>
          <span class="fs-12 color-slaty mb8">Your Location</span>
          <div class="disp-col-inline jcsb mb60">
            <div class="location-container">
              <img
                :src="staticImgBaseUrl + '/images/global/location-icon.svg'"
                alt="location-icon"
              />
              <div class="location-items">
                <span class="lh18 fs-16 bold color-slaty-dark">{{
                  initialValue.geoCode.displayAddress
                }}</span>
                <span class="fs-12 lh14 color-slaty">{{
                  initialValue.geoCode.footerAddress
                }}</span>
              </div>
            </div>
            <button class="change-btn" @click="handleChangeLocation">
              Change
            </button>
          </div>
          <button class="cnfm-loc-btn" @click="handleConfirmLocation">
            Confirm Location & Proceed
          </button>
        </div>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import MapScreenBottomBarShimmer from "./MapScreenBottomBarShimmer.vue";
import GenericModal from "./GenericModal.vue";
import MsgHolder from "./MsgHolder.vue";
import AddressCard from "./AddressCard.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import {
  staticImgBaseUrl,
  clientPlatform,
  showItemToast,
  googleApiEndpoints,
} from "../config/apiEndpoints";
import { load, isGoogleMapLoaded } from "../helpers/landingUtils";
import { OrderTypesCode } from "../helpers/orderTypesConstants";
import {
  EVENT_LOGIN_CTA_CLICKED,
  EVENT_LOCATION_CLICK,
  EVENT_MAP_DRAGGED,
  EVENT_LOCATION_ADDRESS_INPUT,
  EVENT_IMPRESSION_NO_DELIVERY_ZONE,
  EVENT_CONFIRM_LOCATION,
} from "../helpers/analyticsEvents";
import MapUtils from "./../helpers/mapUtils";

export default {
  name: "MapScreen",
  props: ["modulePropsData"],
  components: {
    GenericModal,
    MsgHolder,
    AddressCard,
    MapScreenBottomBarShimmer,
  },
  data() {
    return {
      clientPlatform,
      staticImgBaseUrl,
      LocationModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass: "delivery-map-modal full-screen-popup lg-screen-centered",
      },
      ConfirmAddressModalDim: {
        width: "100vw",
        height: "auto",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "cnfm-address-modal full-screen-popup lg-screen-centered",
      },
      AddEditAddressModalDim: {
        width: "100vw",
        height: "486px",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "add-edit-address-modal",
      },
      msgHolderStyles: {
        bgColor: "$color-alert-light",
        borderColor: "$color-alert-light",
        color: "$color-alert",
      },
      addressCardClass: "mt16",
      drillDown: false,
      value: "",
      predictions: [],
      isOpen: false,
      currentMarker: {},
      draggedLocation: {},
      enablePick: false,
      reset: false,
      isShowMapTooltip: true,
      mapDragged: 0,
      deliverableAreaDragged: 0,
      nonDeliverableAreaDragged: 0,
      mapPageAb: 0,
      nonDeliverable: false,
      nonDeliveryGTMFired: false,
      openConfirmationModal: false, // @todo change it to false
      isAway: false,
      distDiffBtwGpsAndDragLocText: "",
      searchText: "",
      markerTipMessageTop: "",
      markerTipMessageBottom: "",
      mapHeader: "",
      markerTipTop: "200px",
      relocateBottom: "226px",
      footerHeight: 160,
      distanceFromTop: 0,
      markerTipMessageNonDeliverable: "Your Selected Location",
    };
  },
  mounted() {
    this.updateStateFromProps();
    this.$store.commit(keyMapsMutation.TOGGLE_ADD_EDIT_ADDRESS_LOCATION_SCREEN);
    let currentLocation =
      this.showAddAddress &&
      Object.keys(this.getEditAddress).length &&
      !this.isChangeAddressTriggeredInAddEditAddressFlow
        ? {
            lat: this.getEditAddress?.latitude,
            lng: this.getEditAddress?.longitude,
          }
        : Object.keys(this.$store.state.Location.currentLocation).length > 0 &&
          this.$store.state.Location.currentLocation?.lat
        ? this.$store.state.Location.currentLocation
        : {
            lat: 28.60370867315339,
            lng: 77.25934219668501,
          }; // default case if current location is undefined

    if (window.google || isGoogleMapLoaded()) {
      this.initMap(currentLocation);
    } else {
      load(googleApiEndpoints.MAP_URL)
        .then(() => this.initMap(currentLocation))
        .catch(() => this.initMap(currentLocation));
    }
  },
  methods: {
    initMap(currentLocation) {
      this.map =
        window.google &&
        new window.google.maps.Map(this.$refs["map"], {
          center: currentLocation,
          zoom: 17,
          disableDefaultUI: true,
          gestureHandling: "greedy",
        });
      this.updateMarker(currentLocation);
      this.draggedLocation = currentLocation;
      // this.updateMapStyles();

      // Add edit Address changes
      if (
        Utility.checkTriggerLocationScreenForAddEditAddress() &&
        !Utility.checkEditAddressOnLocation()
      ) {
        this.openConfirmationModal = true;
      }
      this.$store.commit(keyMapsMutation.UPDATE_MAP_SCREEN_LOADING, false);
      this.updateFooterDetails();
    },
    updateStateFromProps() {
      this.markerTipMessageTop = this.modulePropsData?.markerTipMessageTop;
      this.markerTipMessageBottom =
        this.modulePropsData?.markerTipMessageBottom;
      this.mapHeader = this.modulePropsData?.mapHeader;
      this.searchText = this.modulePropsData?.searchText;
    },
    updateMarker({ lat = () => {}, lng = () => {} }) {
      const location = {
        lat: typeof lat === "function" ? lat() : lat,
        lng: typeof lng === "function" ? lng() : lng,
      };

      const googleMap =
        window.google &&
        new window.google.maps.Map(this.$refs.map, {
          zoom: 17,
          center: location,
          disableDefaultUI: true,
          gestureHandling: "greedy",
        });

      const query = {
        latitude: location.lat,
        longitude: location.lng,
      };
      if (!window.google) {
        Utility.reloadPage();
      } else {
        this.currentLocationMarkerOnMap(googleMap);
        googleMap.setCenter(location);
        let boolLocation = false;
        google.maps.event.addListener(googleMap, "dragend", () => {
          this.locationSelection(googleMap);
          boolLocation = true;
          EVENT_MAP_DRAGGED({});
        });
        google.maps.event.addListener(googleMap, "zoom_changed", () => {
          this.locationSelection(googleMap);
          boolLocation = true;
        });
        if (!boolLocation) {
          this.locationSelection(googleMap);
        }
      }

      // this.addYourLocationButton(googleMap);
    },
    handleLocationSearchMap() {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
        false
      );
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        true
      );
    },
    currentLocationMarkerOnMap(map) {
      let currentLocation =
        this.$store.state.Location.currentGPSLocationData?.geometry?.location;

      const posImage = {
        url: staticImgBaseUrl + "/images/global/curLocLogo.svg",
        scaledSize: new google.maps.Size(26, 26),
        anchor: new google.maps.Point(20, 20),
      };
      const markerView = MapUtils.addMarker({
        map: map,
        position: currentLocation,
        icon: posImage,
      });
    },
    locationSelection(map) {
      const dragEndLocation = {
        lat: map.getCenter().lat(),
        lng: map.getCenter().lng(),
      };

      this.enablePick = true;
      this.currentMarker = { location: dragEndLocation };

      //  Validiting that delivery is possible at location ;

      let position = {
        coords: {
          latitude: dragEndLocation.lat,
          longitude: dragEndLocation.lng,
        },
        disableStoreFromRecentLocation: true,
      };

      this.draggedLocation = dragEndLocation;
      // this.updateMapStyles();

      this.$store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, position);
      if (LocalStorageFunc.getIsAddEditAddressFlow()) {
        LocalStorageFunc.setCoordsForAddEditAddress({
          latitude: dragEndLocation.lat,
          longitude: dragEndLocation.lng,
        });
      }
      this.isShowMapTooltip = false;
      this.getDistanceDiff();
    },
    handleConfirmLocation() {
      EVENT_LOCATION_CLICK({
        sectionName: "address selection",
        sectionPosition: 2,
        positionWithinSection: 2,
        category: "location set",
        subcategory: "deliverable",
      });
      EVENT_CONFIRM_LOCATION({
        sectionPosition: 2,
        positionWithinSection: 2,
        category: this.isCurrentGPSLocationAvailable
          ? this.distDiffBtwGpsAndDragLocText
            ? "away from gps location"
            : "within gps location"
          : "gps location is off",
      });
      LocalStorageFunc.resetAllSelectedLocations();
      if (this.showAddAddress) {
        Utility.sendToSaveAddressScreen(window.location);
      }
      if (this.selectedOrderType === "D") {
        LocalStorageFunc.setDeliveryType("D");
        LocalStorageFunc.setToastNotifications({
          msg: "Address changed successfully!",
        });
        Utility.redirectToHomeOrRedirectUrl();
      } else {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
          false
        );
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
          false
        );
        this.$store.dispatch(keyMapsAction.LOCATOR_STORE_TAKEAWAY_API, {});
      }
      LocalStorageFunc.updateLastLocationOnConfirmedLocation();

      LocalStorageFunc.setIsChangeAddressTriggeredInAddEditAddressFlow(false);
    },
    handleProceedTakeaway() {
      EVENT_LOCATION_CLICK({
        sectionName: "address selection",
        sectionPosition: 2,
        positionWithinSection: 2,
        category: "address not deliverable",
        subcategory: "switch to takeaway",
      });
      LocalStorageFunc.resetAllSelectedLocations();
      this.$store.commit(
        keyMapsMutation.UPDATE_CURRENT_ORDER_TYPE,
        OrderTypesCode.TAKEAWAY_CODE
      );
      this.$store.commit(
        keyMapsMutation.UPDATE_TAKEAWAY_OR_DINEIN_ON_SELECTION,
        this.nearestTakeawayStore.store
      );
      LocalStorageFunc.setDeliveryTypeStationData(
        this.nearestTakeawayStore.store?.stations[0]
      );
      LocalStorageFunc.updateStoreId(this.nearestTakeawayStore.store?.id);
      LocalStorageFunc.setSelectedStore(this.nearestTakeawayStore.store);
      Utility.redirectToHomeOrRedirectUrl();
    },
    relocateLocation() {
      let currentGPSLocation =
        LocalStorageFunc.getCurrentGPSLocation()?.geometry?.location;
      EVENT_LOCATION_ADDRESS_INPUT({
        userAction: "auto-detect location element click",
        sectionName: "map screen",
        sectionPosition: 2,
        positionWithinSection: 2,
        category: "detect current location on map",
      });
      if (!currentGPSLocation) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_LOCATION_ACCESS_BLOCKED_MODAL,
          true
        );
      } else {
        this.updateMarker(currentGPSLocation);
        this.draggedLocation = currentGPSLocation;
        // this.updateMapStyles();
      }
    },
    handleChangeLocation(type = "") {
      if (type == "close") {
        if (LocalStorageFunc.getIsAddEditAddressFlow()) {
          if (this.isNoDeliveryZone) {
            // LocalStorageFunc.setLocationChangeAddress();
            if (!Utility.isTakeawayOrDineinSelected()) {
              let add = LocalStorageFunc.getEditAddress();
              if (LocalStorageFunc.getIsAddEditAddressFlow() && add.latitude) {
                LocalStorageFunc.setCoordsForAddEditAddress({
                  latitude: add.latitude,
                  longitude: add.longitude,
                });
                this.$store.commit(
                  keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
                  true
                );
                Utility.redirectToHomeOrRedirectUrl();
              } else {
                LocalStorageFunc.setIsAddEditAddressFlow(false);
                LocalStorageFunc.setCoordsForAddEditAddress({});
                LocalStorageFunc.setAddAddressEnable(false);
                this.redirectAfterSaveAddress()
              }
            } else {
              this.$store.commit(
                keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
                true
              );
              Utility.redirectToHomeOrRedirectUrl();
            }
            // LocalStorageFunc.setEditAddresEnable({});
          } else {
            Utility.sendToSaveAddressScreen(window.location);
          }
        }
        LocalStorageFunc.setIsChangeAddressTriggeredInAddEditAddressFlow(false);
      } else {
        LocalStorageFunc.setLocationChangeAddress();
      }
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
        false
      );
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        true
      );
    },
    // refineUserAddress(addressComponents) {
    //   var displayedAddress = [];
    //   addressComponents.forEach(function (v) {
    //     if (
    //       !(
    //         v.types.indexOf("ESTABLISHMENT") !== -1 ||
    //         v.types.indexOf("POINT_OF_INTEREST") !== -1 ||
    //         v.types.indexOf("PREMISE") !== -1 ||
    //         v.types.indexOf("SUBLOCALITY_LEVEL_3") !== -1 ||
    //         v.types.indexOf("ADMINISTRATIVE_AREA_LEVEL_2") !== -1 ||
    //         v.types.indexOf("ADMINISTRATIVE_AREA_LEVEL_1") !== -1 ||
    //         v.types.indexOf("COUNTRY") !== -1 ||
    //         v.types.indexOf("POSTAL_CODE") !== -1 ||
    //         v.types.indexOf("ROUTE") !== -1 ||
    //         v.types.indexOf("NEIGHBORHOOD") !== -1 ||
    //         v.types.indexOf("STREET_NUMBER") !== -1
    //       )
    //     ) {
    //       displayedAddress.push(v.shortName);
    //     }
    //   });
    //   return displayedAddress.join(", ");
    // },
    handleAddNewAddress() {
      if (this.showEditAddressFlow) {
        Utility.sendToSaveAddressScreen(window.location);
      } else {
        LocalStorageFunc.setAddAddressEnable();
        Utility.sendToSaveAddressScreen(window.location);
      }
    },
    redirectAfterSaveAddress() {
      let redirectFrom = LocalStorageFunc.getIsRedirectedFrom();
      LocalStorageFunc.setIsRedirectedFrom("");
      if (redirectFrom == "/my-addresses") {
        Utility.sendToMyAddressPage();
      } else if (redirectFrom == "/cart-unified") {
        Utility.sendToCartScreen();
      } else if (redirectFrom == "/location") {
        Utility.sendToLocationScreen({ noRedirectUrl: true });
      } else {
        Utility.sendToHomepageScreen();
      }
    },
    getDistanceDiff() {
      let currentGPSLocation =
        this.$store.state.Location.currentGPSLocationData?.geometry?.location;

      let markerLocation = this.draggedLocation;

      let diff =
        currentGPSLocation?.lat && markerLocation?.lat
          ? Utility.distanceBetweenTwoCoordinates(
              currentGPSLocation,
              markerLocation
            )
          : 0;

      const distDiffBtwGpsAndDragLoc =
        diff > 300
          ? Math.trunc(diff) > 1000
            ? `${(Math.trunc(diff) / 1000).toFixed(1)}Km`
            : `${Math.trunc(diff)}m`
          : "";
      this.distDiffBtwGpsAndDragLocText = distDiffBtwGpsAndDragLoc
        ? this.modulePropsData?.distanceNudgeText.replace(
            "<distance>",
            distDiffBtwGpsAndDragLoc
          )
        : "";
    },
    updateMapStyles() {
      this.$forceUpdate();
    },
    // getFooterDetails() {
    //   this.$nextTick(() => {
    //     const mapFooterElement = this.$refs.mapFooter;
    //     const footerHeight =
    //       mapFooterElement instanceof HTMLElement
    //         ? mapFooterElement?.getBoundingClientRect()?.height
    //         : 160;
    //     const distanceFromTop =
    //       mapFooterElement instanceof HTMLElement
    //         ? mapFooterElement?.getBoundingClientRect()?.top
    //         : `calc(100vh - ${footerHeight}px)`;

    //     return { footerHeight, distanceFromTop };
    //   });
    // },
    updateFooterDetails() {
      this.$nextTick(() => {
        const mapFooterElement = this.$refs.mapFooter;
        if (mapFooterElement instanceof HTMLElement) {
          this.footerHeight = mapFooterElement.getBoundingClientRect().height;
          this.distanceFromTop = mapFooterElement.getBoundingClientRect().top;
        }
      });
    },
  },
  watch: {
    isLoading(newValue) {
      this.updateMapStyles();
    },
    openConfirmationModal(newValue) {
      this.updateMapStyles();
    },
    isNoDeliveryZone(newValue) {
      if (this.$store.state.Location.noDeliveryZoneData.displayText) {
        EVENT_IMPRESSION_NO_DELIVERY_ZONE({
          category: this.nearestTakeawayStore.store
            ? "unserviceable location"
            : "unserviceable city",
          subCategory:
            this.$store.state.Location.noDeliveryZoneData.displayText,
        });
      }
      this.updateMapStyles();
    },
    distDiffBtwGpsAndDragLocText(newValue) {
      this.updateMapStyles();
    },
    "$refs.mapFooter": "updateFooterDetails",
  },
  updated() {
    this.updateFooterDetails();
  },
  computed: {
    isNoDeliveryZone() {
      return this.$store.state.Location.noDeliveryZoneData.location;
    },
    nearestTakeawayStore() {
      let store = LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp();
      return this.$store.state.Location.takeawayStoreList.length
        ? this.$store.state.Location.takeawayStoreList[0]
        : { store: store?.recent };
    },
    isChangeAddressTriggeredInAddEditAddressFlow() {
      return LocalStorageFunc.getIsChangeAddressTriggeredInAddEditAddressFlow();
    },
    showItemToastMsg() {
      return this.$store.state.Cart.showItemToastMsg && showItemToast;
    },
    itemToastMsg() {
      return this.$store.state.Cart.itemToastMsg;
    },
    getEditAddress() {
      return LocalStorageFunc.getEditAddress();
    },
    isLoggedIn() {
      return LocalStorageFunc.isLoggedIn();
    },
    initialValue() {
      return this.$store.state.Location.geoCodeInitialValue;
    },
    selectedOrderType() {
      return (
        this.$store.state.User.selectedOrderType ||
        this.$store.state.User.currentOrderType
      );
    },
    isLoading() {
      return (
        this.$store.state.Loader.isLoading ||
        !this.initialValue?.geoCode.displayAddress
      );
    },
    isCurrentGPSLocationAvailable() {
      return this.$store.state.Location.currentGPSLocationData?.geometry
        ?.location?.lat;
    },
    showAddAddress() {
      return LocalStorageFunc.getIsAddEditAddressFlow();
    },
    getMapStyles() {
      if (
        this.isLoading ||
        this.openConfirmationModal ||
        this.isNoDeliveryZone ||
        (this.openConfirmationModal && !this.isNoDeliveryZone) ||
        (!this.openConfirmationModal && !this.isNoDeliveryZone) ||
        distDiffBtwGpsAndDragLocText
      ) {
        this.markerTipTop = `calc((100vh - ${this.footerHeight}px) / 2)`;
        this.relocateBottom = `calc(${this.footerHeight}px + 10px)`;
        return { height: `calc(100vh - ${this.footerHeight}px)` };
      }

      this.markerTipTop = this.footerHeight
        ? `calc((100vh - ${this.footerHeight}px) / 2)`
        : `${this.distanceFromTop / 2}px`;
      this.relocateBottom = this.footerHeight
        ? `calc(${this.footerHeight}px + 10px)`
        : "226px";

      return {
        height: this.footerHeight
          ? `calc(100vh - ${this.footerHeight}px)`
          : `${this.distanceFromTop}px`,
      };
    },
  },
};
</script>
